import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1720113316016666'

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)
}

export function useMetaPixel() {
  useEffect(() => {
    try {
      loadPixelScript()
      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e)
    }
  }, [])
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Guía de Sueño Express para Bebés',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed:', e)
  }
}
